import React, { useEffect, useState, useCallback } from 'react'
import Nlayout from './Nlayout'
import { Modal } from '@mui/material'
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import './Tienda.css'
import './MenuTipeos.css'
import { useAuth } from './authContext';
import { generatePKCE } from './api/pkce';
import { FaKickstarterK } from 'react-icons/fa';
import XbetVerificationCard from './components/XbetVerificationCard';

// ─── Tab definitions ───────────────────────────────────────────────────────
const TABS = [
    // { id: 'betwinner', label: 'BETWINNER', cls: 'mt-tab--betwinner' },
    { id: '1xbet', label: '1XBET', cls: 'mt-tab--1xbet' },
    { id: 'verificar', label: 'Verificacion del deposito', cls: 'mt-tab--verificar' },
];

const TEN_HOURS_MS = 18 * 60 * 60 * 1000;
const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

/**
 * Parses date accounting for Argentina Timezone (UTC-3) if string lacks timezone designator.
 */
function parseArgentinaDate(lastDate) {
    if (!lastDate) return 0;
    if (typeof lastDate === 'number') return lastDate;

    let dStr = String(lastDate).trim();

    // Quitar la Z para que se interprete como hora local
    dStr = dStr.replace('Z', '');

    if (dStr.includes(' ') && !dStr.includes('T')) {
        dStr = dStr.replace(' ', 'T');
    }

    const parsed = new Date(dStr).getTime();

    return isNaN(parsed) ? 0 : parsed;
}

/**
 * Hook that returns the remaining time (in ms) until `lastDate + durationMs`.
 * Returns 0 when cooldown has expired or if no valid date is provided.
 */
function useCountdown(lastDate, durationMs = TEN_HOURS_MS) {
    const computeRemaining = useCallback(() => {
        if (!lastDate) return 0;
        const last = parseArgentinaDate(lastDate);
        if (!last) return 0;
        const end = last + durationMs;
        const diff = end - Date.now();
        return diff > 0 ? diff : 0;
    }, [lastDate, durationMs]);

    const [remaining, setRemaining] = useState(() => computeRemaining());

    useEffect(() => {
        setRemaining(computeRemaining());
        if (computeRemaining() <= 0) return;

        const id = setInterval(() => {
            const r = computeRemaining();
            setRemaining(r);
            if (r <= 0) clearInterval(id);
        }, 1000);

        return () => clearInterval(id);
    }, [computeRemaining]);

    return remaining;
}

function formatCountdown(ms) {
    if (ms <= 0) return '';
    const totalSec = Math.ceil(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

function MenuTipeos(props) {
    const { username } = useAuth();
    const nombre = localStorage.getItem('kick_user');

    // counters from API
    const [solicitudes, setSolicitudes] = useState(0);
    const [bonos, setBonos] = useState(0);
    const [bonos2da, setBonos2da] = useState(0);
    const [bonusBetWinner, setBonusBetWinner] = useState(0);
    const [verificarBetWinner, setVerificarBetWinner] = useState(0);
    const [verificar1xBet, setVerificar1xBet] = useState(0);
    const [ultimo1xbet, setUltimo1xbet] = useState();
    const [ultimoTipeoExtra, setUltimoTipeoExtra] = useState();
    const [ultimoVerificar, setUltimoVerificar] = useState();
    const [limiteTipeos, setLimiteTipeos] = useState(null);
    const [xbetId, setXbetId] = useState(null);

    // active tab
    const [activeTab, setActiveTab] = useState('betwinner');

    // toast
    const [monto, setMonto] = useState();

    const [error, setError] = useState(false);
    const [progress, setProgress] = useState(100);
    const duration = 5000;

    // ── fetch ──────────────────────────────────────────────────────────────
    const obtenerCoins = async () => {
        const response = await axios.post('https://backend.eldenguee.com/solicitudes/usuario', { nombre });
        setSolicitudes(response?.data[0]?.solicitudes ?? 0);
        setBonos(response?.data[0]?.bonos ?? 0);
        setBonos2da(response?.data[0]?.Bono2da ?? 0);
        setBonusBetWinner(response?.data[0]?.bonusBet ?? 0);
        setVerificarBetWinner(response?.data[0]?.verificarBet ?? 0);
        setVerificar1xBet(response?.data[0]?.verificar1xBet ?? 0);
        setUltimo1xbet(response?.data[0]?.ultimo_tipeo ?? 0);
        setUltimoTipeoExtra(response?.data[0]?.ultimo_tipeoextra ?? 0);
        setUltimoVerificar(response?.data[0]?.ultimo_verificar ?? response?.data[0]?.ultimo_tipeoextra ?? 0);
        setXbetId(response?.data[0]?.xbet_id ? String(response.data[0].xbet_id).trim() : null);
    };

    const obtenerLimiteTipeos = async () => {
        try {
            const res = await axios.get('https://backend.eldenguee.com/solicitudes/limite-tipeos');
            setLimiteTipeos(res.data);
        } catch (err) {
            console.error('Error al obtener límite de tipeos:', err);
        }
    };

    useEffect(() => {
        obtenerCoins();
        obtenerLimiteTipeos();

        // Actualizar en tiempo real cuando la ventana/pestaña vuelve al frente
        const handleFocus = () => {
            obtenerCoins();
            obtenerLimiteTipeos();
        };
        window.addEventListener('focus', handleFocus);
        const handleVisibility = () => {
            if (document.visibilityState === 'visible') handleFocus();
        };
        document.addEventListener('visibilitychange', handleVisibility);

        // Polling en tiempo real cada 8 segundos mientras está en la pantalla de tipeos
        const interval = setInterval(() => {
            obtenerCoins();
            obtenerLimiteTipeos();
        }, 8000);

        return () => {
            window.removeEventListener('focus', handleFocus);
            document.removeEventListener('visibilitychange', handleVisibility);
            clearInterval(interval);
        };
    }, []);

    const cupoAgotado = Boolean(limiteTipeos?.activo && (limiteTipeos?.disponibles ?? 0) <= 0);
    const tipesRestantes = limiteTipeos?.activo ? (limiteTipeos?.disponibles ?? 0) : null;

    // ── cooldowns ─────────────────────────────────────────────────────────
    const cooldown1xbet = useCountdown(ultimo1xbet, TWENTY_FOUR_HOURS_MS);
    const cooldownExtra = useCountdown(ultimo1xbet, TEN_HOURS_MS);
    const cooldownVerificar = useCountdown(ultimo1xbet, TEN_HOURS_MS);



    // ── redirects ──────────────────────────────────────────────────────────
    const go = (path) => { window.location.href = path; };

    // ── info text per tab ──────────────────────────────────────────────────
    const infoText = {
        betwinner: 'Los tipeos se entregan todos juntos despues de cada directo. Una vez se te acredite el primer tipeo podras reclamar el tipeo extra!',
        '1xbet': 'Los tipeos se entregan automáticamente en el horario que eldenguee haya pactado con su gente (siempre cuando terminan los directos). Una vez se acredite en tu cuenta el tipeo se habilitará la opción para que puedas verificar el deposito!',
        verificar: 'Acá tienes que verificar el deposito de la totalidad del tipeo. Una vez se confirme tu verificación recibirás 1000 D-COINS que podrás utilizarlas en el shop!',
    };

    const informacion = {
        texto: 'Si a la hora de reclamar un tipeo se te queda la pantalla en negro en algún paso intenta reclamarlo en modo incógnito'
    }

    const visibleTabs = TABS.filter(tab => {
        switch (tab.id) {
            case 'betwinner':
                return username && (solicitudes > 0 || bonusBetWinner > 0);

            case '1xbet':
                return username && (bonos > 0 || bonos2da > 0);

            case 'verificar':
                return username && (verificarBetWinner > 0 || verificar1xBet > 0);

            default:
                return false;
        }
    });

    useEffect(() => {
        if (visibleTabs.length === 0) return;

        // Si el tab actual no existe, seleccionar el primero disponible
        if (!visibleTabs.some(tab => tab.id === activeTab)) {
            setActiveTab(visibleTabs[0].id);
        }
    }, [visibleTabs, activeTab]);
    const loginWithKick = async () => {
        const { code_verifier, code_challenge } = await generatePKCE();
        localStorage.setItem('kick_code_verifier', code_verifier);
        const criptoRandom = crypto.randomUUID();
        const params = new URLSearchParams({
            response_type: 'code',
            client_id: '01JW6K1RY4R70K7B6KSJ8GK5CV',
            redirect_uri: 'https://eldenguee.com/callback',
            scope: 'chat:write channel:read user:read events:subscribe',
            code_challenge: code_challenge,
            code_challenge_method: 'S256',
            state: criptoRandom,
        });
        window.location.href = `https://id.kick.com/oauth/authorize?${params.toString()}`;
    };

    // ── Not logged in ─────────────────────────────────────────────────────
    if (!username) {
        return (
            <Nlayout>
                <div className="mt-bg">
                    <div className="mt-container">
                        <div className="mt-header">
                            <h1 className="mt-title">Tipeos</h1>
                            <p className="mt-subtitle">Aqui puedes reclamar los tipeos que ganaste en los sorteos!</p>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '24px',
                            padding: '60px 20px',
                            textAlign: 'center',
                        }}>
                            <div style={{
                                width: '72px',
                                height: '72px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(0, 255, 115, 0.1)',
                                border: '2px solid rgba(0, 255, 115, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <FaKickstarterK size={32} color="#00ff73" />
                            </div>
                            <div>
                                <h2 style={{
                                    color: '#ffffff',
                                    fontFamily: 'Outfit, sans-serif',
                                    fontSize: '1.5rem',
                                    fontWeight: 'bold',
                                    margin: '0 0 8px',
                                }}>Necesitás iniciar sesión</h2>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.5)',
                                    fontSize: '0.95rem',
                                    margin: 0,
                                    maxWidth: '400px',
                                    lineHeight: '1.5',
                                }}>Para acceder a tus tipeos y reclamar tus premios, iniciá sesión con tu cuenta de Kick.</p>
                            </div>
                            <button
                                onClick={loginWithKick}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    padding: '14px 32px',
                                    backgroundColor: '#00ff73',
                                    color: '#000',
                                    border: 'none',
                                    borderRadius: '12px',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    fontFamily: 'Outfit, sans-serif',
                                    cursor: 'pointer',
                                    boxShadow: '0 0 20px rgba(0, 255, 115, 0.3)',
                                    transition: 'all 0.2s ease',
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; e.currentTarget.style.boxShadow = '0 0 30px rgba(0, 255, 115, 0.5)'; }}
                                onMouseOut={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 0 20px rgba(0, 255, 115, 0.3)'; }}
                            >
                                <FaKickstarterK size={18} />
                                Ingresar con Kick
                            </button>
                        </div>
                    </div>
                </div>
            </Nlayout>
        );
    }

    return (
        <Nlayout>
            <div className="mt-bg">
                <div className="mt-container">

                    {/* ── Header ── */}
                    <div className="mt-header">
                        <h1 className="mt-title">Tipeos</h1>
                        <p className="mt-subtitle">Aqui puedes reclamar los tipeos que ganaste en los sorteos!</p>
                        {limiteTipeos?.activo && (
                            <div className="mt-cupo">
                                {cupoAgotado ? (
                                    <span className="mt-cupo__agotado">Sin tipeos disponibles</span>
                                ) : (
                                    <span className="mt-cupo__restantes">
                                        Quedan <strong>{tipesRestantes}</strong> tipeo{tipesRestantes === 1 ? '' : 's'} disponible{tipesRestantes === 1 ? '' : 's'}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ── Tab bar ── */}
                    <div className="mt-tabs">
                        {visibleTabs.map(tab => (
                            <button
                                key={tab.id}
                                className={`mt-tab ${tab.cls} ${activeTab === tab.id ? 'mt-tab--active' : ''}`}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* ── Panels ── */}
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeTab}
                            className="mt-panel"
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -12 }}
                            transition={{ duration: 0.25 }}
                        >
                            {/* ─── BETWINNER ─── */}

                            {/* {activeTab === 'betwinner' && (<>
                                <div className="mt-action-wrap">
                                    {username && solicitudes > 0 && (
                                        <span className="mt-badge">{solicitudes}</span>
                                    )}
                                    {username && solicitudes > 0 && (
                                        <button className="mt-action-btn mt-action-btn--green" onClick={() => go('/tipeo')}>
                                            RECLAMAR TIPEO DE BETWINNER
                                        </button>
                                    )}
                                </div>
                                {username && bonusBetWinner > 0 && (
                                    <div className="mt-action-wrap" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                                        <div
                                            style={{
                                                backgroundColor: 'rgba(245, 158, 11, 0.15)',
                                                color: '#fbbf24',
                                                border: '1px dashed #f59e0b',
                                                borderRadius: '8px',
                                                padding: '6px 14px',
                                                fontSize: '0.85rem',
                                                fontWeight: 'bold',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                boxShadow: '0 2px 8px rgba(245, 158, 11, 0.15)',
                                            }}
                                        >
                                            {cooldownExtra && <span>⏰ Tenés 16 horas para reclamar</span>}
                                            {cooldownExtra > 0 && (
                                                <span style={{ backgroundColor: 'rgba(245, 158, 11, 0.25)', padding: '2px 8px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '0.9rem' }}>
                                                    {formatCountdown(cooldownExtra)}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <span className="mt-badge">{bonusBetWinner}</span>
                                            <button className="mt-action-btn mt-action-btn--green" onClick={() => go('/bonusBetWinner')}>
                                                RECLAMAR TIPEO EXTRA DE BETWINNER
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>)}
*/}
                            {/* ─── 1XBET ─── */}
                            {activeTab === '1xbet' && (<>
                                <XbetVerificationCard
                                    username={nombre || username}
                                    initialXbetId={xbetId}
                                    onVerified={(id) => setXbetId(id)}
                                />
                                <div className="mt-action-wrap">
                                    {username && bonos > 0 && (
                                        <span className="mt-badge">{bonos}</span>
                                    )}
                                    {username && bonos > 0 && (
                                        !xbetId ? (
                                            <button
                                                className="mt-action-btn mt-action-btn--gray"
                                                disabled
                                                style={{ cursor: 'not-allowed', opacity: 0.7 }}
                                                title="Debes ingresar y confirmar tu 1XBET ID arriba para poder reclamar"
                                            >
                                                RECLAMAR TIPEO DE 1XBET (Requiere 1XBET ID 🔒)
                                            </button>
                                        ) : cupoAgotado ? (
                                            <button
                                                className="mt-action-btn mt-action-btn--gray"
                                                disabled
                                                style={{ cursor: 'not-allowed', opacity: 0.6 }}
                                            >
                                                SOLICITAR TIPEO (Sin cupos disponibles)
                                            </button>
                                        ) : cooldown1xbet > 0 ? (
                                            <button
                                                className="mt-action-btn mt-action-btn--gray"
                                                disabled
                                                style={{ cursor: 'not-allowed', opacity: 0.6 }}
                                            >
                                                RECLAMAR TIPEO DE 1XBET (Disponible en {formatCountdown(cooldown1xbet)})
                                            </button>
                                        ) : (
                                            <button className="mt-action-btn mt-action-btn--blue" onClick={() => go('/bonos')}>
                                                RECLAMAR TIPEO DE 1XBET
                                            </button>
                                        )
                                    )}
                                </div>
                                {/* {bonos2da > 0 && (
                                    <div className="mt-action-wrap" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                                        <div
                                            style={{
                                                backgroundColor: 'rgba(245, 158, 11, 0.15)',
                                                color: '#fbbf24',
                                                border: '1px dashed #f59e0b',
                                                borderRadius: '8px',
                                                padding: '6px 14px',
                                                fontSize: '0.85rem',
                                                fontWeight: 'bold',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                boxShadow: '0 2px 8px rgba(245, 158, 11, 0.15)',
                                            }}
                                        >
                                            {cooldownExtra && <span>⏰ Tenés 16 horas para reclamar</span>}
                                            {cooldownExtra > 0 && (
                                                <span style={{ backgroundColor: 'rgba(245, 158, 11, 0.25)', padding: '2px 8px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '0.9rem' }}>
                                                    {formatCountdown(cooldownExtra)}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            {username && (
                                                <span className="mt-badge">{bonos2da}</span>
                                            )}
                                            <button className="mt-action-btn mt-action-btn--blue" onClick={() => go('/bonus1xbet')}>
                                                RECLAMAR TIPEO EXTRA 1XBET
                                            </button>
                                        </div>
                                    </div>
                                )} */}
                            </>)}

                            {/* ─── VERIFICACION ─── */}
                            {activeTab === 'verificar' && (<>
                                {/* {username && verificarBetWinner > 0 && (
                                    <div className="mt-action-wrap" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                                        <div
                                            style={{
                                                backgroundColor: 'rgba(245, 158, 11, 0.15)',
                                                color: '#fbbf24',
                                                border: '1px dashed #f59e0b',
                                                borderRadius: '8px',
                                                padding: '6px 14px',
                                                fontSize: '0.85rem',
                                                fontWeight: 'bold',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                boxShadow: '0 2px 8px rgba(245, 158, 11, 0.15)',
                                            }}
                                        >
                                            {cooldownVerificar && <span>⏰ Tenés 16 horas para reclamar</span>}

                                            {cooldownVerificar > 0 && (
                                                <span style={{ backgroundColor: 'rgba(245, 158, 11, 0.25)', padding: '2px 8px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '0.9rem' }}>
                                                    {formatCountdown(cooldownVerificar)}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <span className="mt-badge">{verificarBetWinner}</span>
                                            <button className="mt-action-btn mt-action-btn--green" onClick={() => go('/verificarBet')}>
                                                VERIFICAR TIPEO EXTRA BETWINNER
                                            </button>
                                        </div>
                                    </div>
                                )}*/}

                                {username && verificar1xBet > 0 && (
                                    <div className="mt-action-wrap" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                                        {cooldownVerificar > 0 && (
                                            <div
                                                style={{
                                                    backgroundColor: 'rgba(245, 158, 11, 0.15)',
                                                    color: '#fbbf24',
                                                    border: '1px dashed #f59e0b',
                                                    borderRadius: '8px',
                                                    padding: '6px 14px',
                                                    fontSize: '0.85rem',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    boxShadow: '0 2px 8px rgba(245, 158, 11, 0.15)',
                                                }}
                                            >
                                                <span>⏰ Tenés 18 horas para verificar</span>
                                                <span style={{ backgroundColor: 'rgba(245, 158, 11, 0.25)', padding: '2px 8px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '0.9rem' }}>
                                                    {formatCountdown(cooldownVerificar)}
                                                </span>
                                            </div>
                                        )}
                                        <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <span className="mt-badge">{verificar1xBet}</span>
                                            <button className="mt-action-btn mt-action-btn--blue" onClick={() => go('/verificar1xBet')}>
                                                VERIFICAR DEPOSITO DEL TIPEO
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>)}
                        </motion.div>
                    </AnimatePresence>

                    {/* ── Info box ── */}
                    <div className="mt-info">
                        <p className="mt-info__title">Importante</p>
                        <p className="mt-info__text">{infoText[activeTab]}</p>
                    </div>
                    <div className="mt-info">
                        <p className="mt-info__title" style={{ color: 'red' }}>Importante</p>
                        <p className="mt-info__text" style={{ color: 'red' }}>{informacion.texto}</p>
                    </div>

                </div>
            </div>


        </Nlayout>
    );
}

export default MenuTipeos;